export async function fetchData(url: string): Promise<any> {
  let urlSend = `${process.env.REACT_APP_API_CONSULTA}/${url}`

  try {
    const response = await fetch(urlSend, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const data = await response.json()
    return data
  } catch (error) {
    console.error('Error fetching data:', error)
    throw error
  }
}
